import icon01 from '@/assets//images/analytics/icon-01.svg'
import icon02 from '@/assets/images/analytics/icon-02.svg'
import icon03 from '@/assets/images/analytics/icon-03.svg'
import icon04 from '@/assets/images/analytics/icon-04.svg'
import icon05 from '@/assets/images/analytics/icon-05.svg'
import icon06 from '@/assets/images/analytics/icon-06.svg'
import icon07 from '@/assets/images/analytics/icon-07.svg'
import icon08 from '@/assets/images/analytics/icon-08.svg'

export default {
	general:
		[
			{
				id: 1,
				icon: icon01,
				name: "Общая аналитика для группы респондентов",
				keys: "",
				description: "Анализирует результаты тестирования выбранной группы: средние показатели по всем метрикам, распределения по уровням развития и ключевые сильные/слабые зоны.",
				tag: 'Сравнение групп',
				link: "/analytics/base"
			},
			{
				id: 2,
				icon: icon02,
				name: "Сравнение групп",
				keys: "",
				description: "Сопоставляет две группы по тем же ключевым метрикам, показывая различия в уровнях развития, профилях и доминирующих компетенциях.",
				tag: 'Сравнение групп',
				link: "/analytics/group"
			},
			{
				id: 3,
				icon: icon03,
				name: "Аналитика при повторном тестировании",
				keys: "",
				description: "Сравнивает показатели одной и той же группы между первичным и повторным проходами теста, показывая изменения после обучения или других вмешательств.",
				tag: 'Одна группа',
				link: "/analytics/repeated"
			},
			{
				id: 4,
				icon: icon04,
				name: "Аналитика динамики среднего профиля",
				keys: "",
				description: "Отслеживает изменения средних показателей группы в разные периоды времени, позволяя видеть развитие и тенденции без привязки к конкретным людям.",
				tag: 'Для всех сотрудников',
				link: "/analytics/dynamic"
			},
			{
				id: 5,
				icon: icon01,
				name: "Аналитика по демографическим показателям",
				keys: "",
				description: "Анализирует результаты тестирования с разбиением по полу и возрасту, показывая различия и тенденции внутри демографических групп.",
				tag: 'Для всех сотрудников',
				link: "/analytics/demographic"
			},
		],
		special: [
		{
			id: 8,
			icon: icon06,
			name: "Эталонный профиль",
			keys: "",
			description: "Определяет, какие параметры ЭИ связаны с высоким достижением KPI на конкретной должности, и формирует эталон компетенций на основе данных минимум 60 сотрудников. Позволяет сравнивать результаты сотрудников с эталоном и классифицировать их по уровню соответствия.",
			tag: 'От 60 сотрудников',
			link: "/analytics/reference",
			available: true,
			product_id: 'reference_profile',
		},
	],
		admin: [
		{
			id: 7,
			icon: "fa-table",
			name: "Сводная таблица по доступным курсам/тестам",
			keys: "",
			description: "",
			link: "/analytics/summary"
		},
		{
			id: 8,
			icon: "fa-table",
			name: "Подробный отчёт по курсам/тестам",
			keys: "",
			description: "",
			link: "/analytics/general"
		},
		{
			id: 9,
			icon: "fa-table",
			name: "Данные по тестированиям",
			keys: "",
			description: "",
			link: "/analytics/testing_data"
		}
	]
}
